import React from 'react';
import CircularProgress, {
    CircularProgressProps,
} from '@mui/material/CircularProgress';
import './SpinnerStyle.scss';
import CustomImg from '../CustomImage/CustomImg';
import CustomTypography, {
    TypographyType,
} from '../Typography/CustomTypography';
import FlexContainer from '../Container/FlexContainer';
import { joinMultipleStyle } from '../../Utils/ScssUtils';

export interface ICustomizedCircularProgress extends CircularProgressProps {
    loadingPercentage: number;
    displayPercentage?: boolean;
    loadingText: string;
    spinnerContainerClassName?: string;
    loadingTextClassName?: string;
    displayTickMark?: boolean;
}

export default function CustomizedCircularProgressPercent(
    props: ICustomizedCircularProgress
): React.ReactElement {
    return (
        <div
            className={joinMultipleStyle(
                'spinnerContainerPercent',
                props.spinnerContainerClassName
            )}
        >
            <CustomImg
                imgType={'iconLarge'}
                id={`img-loading-img`}
                className={'displayimage'}
                src={`/resources/sharedAcrossWorkflows/wait-asset.svg`}
                alt={props.loadingText}
            />
            {/* change to new className instead since CURRENTLY only fine tuning using this component */}
            <CircularProgress
                id={'progress-loading'}
                className={'movingprogress-finetuning'}
                size={'12vh'}
                thickness={2}
                variant="determinate"
                value={props.loadingPercentage}
            />
            <div>
                <FlexContainer flexRow>
                    <CustomTypography
                        type={TypographyType.notoSansBody16px}
                        text={props.loadingText}
                        className={joinMultipleStyle(
                            'displaytextbottom',
                            props.loadingTextClassName
                        )}
                    />
                    {props.displayTickMark ? (
                        <CustomImg
                            id={`img-tickMark`}
                            className={'tickMark'}
                            src={`/resources/fineTuningWorkflow/Tick-mark.svg`}
                            alt="tickMark"
                        />
                    ) : (
                        <div></div>
                    )}
                </FlexContainer>

                {props.displayPercentage ? (
                    <CustomTypography
                        type={TypographyType.notoSansBody16px}
                        text={`${props.loadingPercentage}%`}
                        className={'displaytextcaption'}
                    />
                ) : (
                    <div></div>
                )}
            </div>
        </div>
    );
}
